import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../ui/button';
import { Plus } from 'lucide-react';

export function PageHeader({ title, description, action, actionLabel, actionIcon: ActionIcon = Plus, children }) {
  const renderAction = () => {
    if (children) {
      return <div className="flex items-center gap-2">{children}</div>;
    }
    if (action) {
      return (
        <Button onClick={action} data-testid={`${title.toLowerCase().replace(/\s+/g, '-')}-create-button`}>
          <ActionIcon className="h-4 w-4 mr-2" />
          {actionLabel}
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {renderAction()}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.func,
  actionLabel: PropTypes.string,
  actionIcon: PropTypes.elementType,
  children: PropTypes.node,
};
